import { httpByGz } from "@/api/config.js";
// import qs from "qs";
//cookie参数
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

//保存音频
export const SaveResultApi = (dataObj) => {
  let data = "";
  for (let key in dataObj) {
    let type = typeof dataObj[key];
    if (type == "number" || type == "string") {
      data += `${key}=${dataObj[key]}&`;
    } else {
      data +=
        key + "=" + encodeURIComponent(JSON.stringify(dataObj[key])) + "&";
    }
  }
  return httpByGz.post(`gz/oral/saveEvalResult`, data);
};
//提交考试
export const SubmitExamApi = (dataObj) => {
  let data = "";
  for (let key in dataObj) {
    let type = typeof dataObj[key];
    if (type == "number" || type == "string") {
      data += `${key}=${dataObj[key]}&`;
    } else {
      data +=
        key + "=" + encodeURIComponent(JSON.stringify(dataObj[key])) + "&";
    }
  }
  return httpByGz.post(`gz/oral/saveAnswer`, data);
};

export const oralAudioApi = (dataObj) => {
  let data = "";
  for (let key in dataObj) {
    let type = typeof dataObj[key];
    if (type == "number" || type == "string") {
      data += `${key}=${dataObj[key]}&`;
    } else {
      data +=
        key + "=" + encodeURIComponent(JSON.stringify(dataObj[key])) + "&";
    }
  }
  return httpByGz.post(`/gz/oral/getOralAudio`, data);
};
